<template>
  <table>
    <template v-for="legend in legendEntries"  :key="legend.legendText">
      <tr>
        <td>
          <div :style="legend.legendColor" class="color"/>
        </td>
        <td>
          <div v-html="legend.legendText"/>
        </td>
      </tr>
    </template>
  </table>
</template>

<script>
export default {
  name: 'legendMenu',
  props: ['legendEntries'],
  components: {},
}
</script>

<style lang="sass">
.color
  border-radius: 3px
  display: block
  height: 21px
  width: 21px
  margin: 3px 4px 0 0
</style>
